import {
  DeliveryBoxIcon,
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  PinterestIcon,
  PlayIcon,
  StrikkefasthetIcon,
  ThicknessIcon,
  TwitterIcon,
  YarnIcon,
  YoutubeIcon
} from "@/assets";
import { MediaCardStoryblok } from "@/types/blok-types";

const SomeIcon = ({
  socialIcon
}: {
  socialIcon: MediaCardStoryblok["socialIcon"];
}) => {
  if (!socialIcon || typeof socialIcon !== "string") return null;
  switch (socialIcon?.toLowerCase()) {
    case undefined:
    case null:
    case "":
      return null;
    case "instagram":
      return <InstagramIcon />;
    case "linkedin":
      return <LinkedInIcon />;
    case "facebook":
      return <FacebookIcon />;
    case "twitter":
      return <TwitterIcon />;
    case "youtube":
      return <YoutubeIcon />;
    case "pinterest":
      return <PinterestIcon />;
    case "play":
      return <PlayIcon />;
    case "deliverybox":
      return <DeliveryBoxIcon />;
    case "strikkefasthet":
      return <StrikkefasthetIcon />;
    case "thickness":
      return <ThicknessIcon />;
    case "yarn":
      return <YarnIcon />;
    default:
      return null;
  }
};

export default SomeIcon;
